import moment from 'moment'

export default {
  install(Vue, options) {
    Vue.prototype.$formatDateBR = (date) => {
      return moment.utc(date).format('DD/MM/YYYY')
    }
  }
}
